import { useClickHref } from '@servicetitan/cp-react-hooks';
import { Button, ButtonPropsStrict, Link, LinkPropsStrict } from '@servicetitan/design-system';
import { FC, ReactNode } from 'react';

export const ContentLink: FC<LinkPropsStrict & { href: string; children?: ReactNode }> = props => {
    const clickProps = useClickHref(props.href);

    return <Link {...props} {...clickProps} />;
};

export const ContentButton: FC<
    ButtonPropsStrict & { href: string; children?: ReactNode }
> = props => {
    const clickProps = useClickHref(props.href);

    return <Button {...props} {...clickProps} />;
};
